<template lang="pug">
  b-modal#editRTFComm(
  ref="editRTFComm"
  :title="$t('ui.combine.edit_rtf')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown")
    b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
      b-form-group(:label="$t('ui.id')").mb-3
        div.form-control.form-control-sm.disabled {{ getRTFCommId }}
      b-form-group(:label="$t('ui.name')").mb-0
        DebounceInput(
          size="sm"
          ref="dataEdit_rtfName"
          required
          type="text"
          :dirty="$v.dataEdit_rtfName.$dirty"
          :error="$v.dataEdit_rtfName.$error"
          v-model.trim.lazy="$v.dataEdit_rtfName.$model"
          :disabled="loading"
          @focus.native="$event.target.select()"
          :maxLength="$v.dataEdit_rtfName.$params.maxLength.max"
        )
        ValidateResult(:value="$v.dataEdit_rtfName" :name="$t('ui.name')")
      b-form-group(:label="$t('ui.description')").mb-0
        DebounceInput(
          size="sm"
          ref="dataEdit_rtfDescription"
          required
          type="text"
          v-model="dataEdit_rtfDescription"
          :disabled="loading"
          @focus.native="$event.target.select()"
        )
      div.row
        div.col
          b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
    div(slot="modal-cancel")
      SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  props: {
    rtfId: "",
    rtfName: "",
    rtfDesc: ""
  },
  data() {
    return {
      dataEdit_rtfName: "",
      dataEdit_rtfDescription: "",
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  computed: {
    getRTFCommId: function() {
      return this.rtfId;
    }
  },
  validations: {
    dataEdit_rtfName: {
      required,
      minLength: minLength(1),
      maxLength: maxLength(100)
    }
  },
  watch: {
    rtfName: function(newVal) {
      this.dataEdit_rtfName = newVal;
    },
    rtfDesc: function(newVal) {
      this.dataEdit_rtfDescription = newVal;
    }
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.editRtfCommUrl();

        var json = {
          action_by: this.$store.getters.username,
          session_token: this.$store.getters.sessionToken,
          page_id: config.accessRoles.rtfcommentary,
          RTFCommentaryID: this.rtfId,
          RTFCommentaryName: this.dataEdit_rtfName,
          RTFCommentaryDescription: this.dataEdit_rtfDescription
        };

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked", this.rtfId, this.dataEdit_rtfName, this.dataEdit_rtfDescription);
                  this.$refs.editRTFComm.hide();
                } else {s
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "edit_rtf", this.feedback.status);
                  this.$refs.editRTFComm.hide();
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
      this.dataEdit_rtfName = this.rtfName;
    },
    shown: function() {
      this.$v.$reset();
      this.$refs.dataEdit_rtfName.$el.focus();
    }
  }
};
</script>
